/**
 * Liefert die URL nur dann zurück, wenn sie ein absolutes http(s)-Ziel ist.
 * Alles andere (javascript:, data:, relative Pfade, Müll) ergibt null und darf
 * nicht als Link gerendert werden.
 */
export function safeHttpUrl(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  try {
    const url = new URL(trimmed);
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.toString() : null;
  } catch {
    return null;
  }
}
